export function formatDate(dateString) {
  if (dateString.length === 4) return dateString;
  return new Date(dateString).toDateString().split(" ").slice(1).join(" "); // Remove day of week
}

/**
 * returns a date string in the format yyyy-mm-dd
 * @param d - Date object
 */
export function toLocaleISO(d) {
  if (!(d instanceof Date)) throw "d must be a Date object";
  return (
    d.getFullYear() +
    "-" +
    (d.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    d.getDate().toString().padStart(2, "0")
  );
}

/**
 * @param timestamp - unix timestamp in miliseconds
 * @returns {string} - date in format yyyy-mm-dd
 */
export function timestampToLocaleISO(timestamp) {
  const date = new Date(timestamp);
  return toLocaleISO(date);
}

// Adapted from https://stackoverflow.com/questions/6108819/javascript-timestamp-to-relative-time
export function relativeDateString(timeStamp) {
  const TELEMONIAL_RELEASE_TIMESTAMP = 1628518413174;
  if (timeStamp <= TELEMONIAL_RELEASE_TIMESTAMP) {
    return "date unknown";
  }

  const units = {
    year: 24 * 60 * 60 * 1000 * 365,
    month: (24 * 60 * 60 * 1000 * 365) / 12,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000,
  };

  const rtf = new Intl.RelativeTimeFormat("en");

  // "Math.abs" accounts for both "past" & "future" scenarios
  const elapsed = timeStamp - Date.now();
  for (const u in units) {
    if (Math.abs(elapsed) > units[u] || u === "second") {
      return rtf.format(Math.round(elapsed / units[u]), u);
    }
  }
}
